import ScheduleDemoSuccessModal from "@/components/MarketingPage/ScheduleDemoSuccessModal";
import Footer, { FooterDataType } from "@/components/organisms/Footer";
import { Navbar } from "@/components/organisms/Navbar";
import { NavbarDataType } from "@/shared/data/navbar.data";
import useThemeStore from "@/shared/store/useThemeStore";
import React from "react";

interface MainLayoutProps {
  children: React.ReactElement | React.ReactElement[];
  pageLink?: string;
  noMenu?: boolean;
  noContainer?: boolean;
  isTransparent?: boolean;
  newFooter?: boolean;
  showScheduleDemo?: boolean;
  noOverflow?: boolean;
  showFooter?: boolean;
  noLogo?: boolean;
  primaryCta?: any;
  hideNavLinks?: boolean;
  hideNavCta?: boolean;
  navbarData: NavbarDataType;
  footerData: FooterDataType;
}

const MainLayout: React.FC<MainLayoutProps> = ({
  children,
  pageLink,
  primaryCta,
  noMenu,
  noContainer,
  isTransparent,
  newFooter,
  noOverflow,
  showScheduleDemo,
  showFooter = true,
  noLogo,
  hideNavLinks,
  hideNavCta,
  navbarData,
  footerData,
}) => {
  const { bodyBg, fontFamily } = useThemeStore();

  return (
    <div
      className={`flex ${fontFamily} min-h-screen flex-col ${bodyBg}  ${
        !noOverflow && "overflow-clip" // changed this to "" from "overflow-hidden"
      }`}
    >
      <Navbar
        navbarData={{
          navbarItems: [],
          signupCopies: navbarData.signupCopies,
          graphyLogoOnClick: navbarData.graphyLogoOnClick,
          promotionStripData: navbarData.promotionStripData,
          promotionStripDataUS: navbarData?.promotionStripDataUS,
          registrationButton: navbarData?.registrationButton,
          registrationButtonUS: navbarData?.registrationButtonUS,
        }}
        showBookDemoBtn={true}
        hideNavCta={hideNavCta}
      />

      <div className="">{children}</div>
      {showFooter && <Footer footerData={footerData} />}
      <ScheduleDemoSuccessModal />
    </div>
  );
};

MainLayout.defaultProps = {
  noContainer: false,
  isTransparent: false,
  newFooter: false,
  noOverflow: false,
  showScheduleDemo: false,
  showFooter: true,
  noLogo: false,
  hideNavLinks: false,
  primaryCta: null,
  pageLink: "/store",
};

export default MainLayout;
